import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import {
  Form,
  FormGroup,
  FormFeedback,
  Error,
  Fade,
  Button,
  Password,
  Modal
} from "../../simple";
import SVG from "../../SVG";
import { validate, validationRules } from "../../../helpers/validate";
import { resetAuthError as resetErrorAction } from "../../../store/actions/auth";

class RestorePasswordForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data: {
        password: "",
        passwordConfirm: ""
      },
      validation: {
        password: true,
        passwordConfirm: true
      }
    };
    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  handleChange(name, value) {
    const { nonFieldErrors, resetAuthError } = this.props;
    const {
      data: { password }
    } = this.state;

    if (nonFieldErrors) resetAuthError();
    this.setState(({ data, validation }) => ({
      data: { ...data, [name]: value },
      validation: {
        ...validation,
        [name]:
          name === "passwordConfirm"
            ? value === password
            : validate(value, validationRules[name])
      }
    }));
  }

  handleSubmit(evt) {
    evt.preventDefault();
    this.props.handleSubmit(this.state.data);
  }

  render() {
    const {
      data: { password, passwordConfirm },
      validation
    } = this.state;
    const { nonFieldErrors } = this.props;
    const isSubmitDisabled = !(
      password &&
      validation.password &&
      validation.passwordConfirm
    );

    return (
      <Form onSubmit={this.handleSubmit} className="restore-password-form">
        <h2 className="title">Create new password</h2>
        <SVG.Lock className="form-icon" />
        <FormGroup>
          <Password
            value={password}
            label="Password"
            name="password"
            placeholder="Password"
            invalid={!validation.password}
            handleChange={this.handleChange}
            required
            fieldError="Please, provide a password, with at least 1 upper case, numeric, and special character"
          />
          <Password
            value={passwordConfirm}
            label="Confirm password"
            name="passwordConfirm"
            placeholder="Confirm password"
            invalid={!validation.passwordConfirm}
            handleChange={this.handleChange}
            required
            fieldError="Please, confirm your password"
          />
          <Fade in={!!nonFieldErrors} tag="div" className="form-error">
            <Error component={FormFeedback} error={nonFieldErrors} />
          </Fade>
        </FormGroup>
        <Button type="submit" className="button" disabled={isSubmitDisabled}>
          Continue
          <SVG.Arrow className="icon" />
        </Button>
      </Form>
    );
  }
}

RestorePasswordForm.propTypes = {
  nonFieldErrors: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.arrayOf(PropTypes.string),
    PropTypes.shape({})
  ]),
  handleSubmit: PropTypes.func.isRequired,
  resetAuthError: PropTypes.func.isRequired
};

RestorePasswordForm.defaultProps = {
  nonFieldErrors: ""
};

const mapStateToProps = ({ auth }) => {
  return {
    nonFieldErrors: auth.error && auth.error.nonFieldErrors
  };
};

const mapDispatchToProps = dispatch => {
  return {
    resetAuthError: () => dispatch(resetErrorAction())
  };
};

const RestorePasswordFormContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(RestorePasswordForm);

export default RestorePasswordFormContainer;

export function RestorePasswordModal(props) {
  const { isOpen, goBackAction, ...formProps } = props;

  return (
    <Modal className="restore-password screen-modal" isOpen={isOpen}>
      <Button className="btn-transparent close-modal" onClick={goBackAction}>
        <SVG.Arrow className="arrow-right-red" width={18} height={13} />
        Back
      </Button>
      <RestorePasswordFormContainer {...formProps} />
    </Modal>
  );
}

RestorePasswordModal.propTypes = {
  isOpen: PropTypes.bool,
  goBackAction: PropTypes.func.isRequired
};

RestorePasswordModal.defaultProps = {
  isOpen: true
};
